import React from "react";
import { useState, useEffect, useMemo, useCallback, useContext, useRef } from "react";
import { getExam } from "../../services/api";
import { useNavigate } from "react-router-dom";
import Loader from '../../images/loader.png';
// import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { submitExam, updateTotalTimeElapsed } from "../../services/api";
import { Link } from "react-router-dom";
import startnow from "../../images/quiz_pic.png";
import { CourseContext } from "./CourseContext";


const Exam = ()=>{
	const [loading, setLoading] = useState(true);
	const [finalanswers, setFinalanswers] = useState({});
  const [finalquestions, setFinalquestions] = useState([]);
  const [quizerror, setQuizError] = useState(false);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [currentquiztime, setCurrentquiztime] = useState();
  const [splashscreen, setSplashscreen] = useState(true);
  const {
    totalTimeElapsed,
    setTotalTimeElapsed,
    breakpoint1,
    setBreakpoint1,
    breakpoint2,
    setBreakpoint2,
    showChallengeModal,
    setShowChallengeModal,
  } = useContext(CourseContext);

  // Track which breakpoints have been asked in this session (for local tracking)
  const [askedBreakpoints, setAskedBreakpoints] = useState(() => {
    try {
      const stored = sessionStorage.getItem("asked_breakpoints");
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });
  const prevTotalTimeElapsedRef = useRef(totalTimeElapsed);
  const canGoNext = useMemo(() => (
    currentQuestionIndex === finalquestions.length - 1 ||
    (currentQuestionIndex === Object.keys(finalanswers).length)
  ), [currentQuestionIndex, finalquestions.length, finalanswers]);

	const navigate = useNavigate();

  // Format seconds to HH:MM:SS
  const formatTime = (seconds) => {
    if (seconds === null || seconds === undefined) return 'N/A';
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    return `${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  // Persist askedBreakpoints to sessionStorage
  useEffect(() => {
    sessionStorage.setItem("asked_breakpoints", JSON.stringify(askedBreakpoints));
  }, [askedBreakpoints]);

  // If a new attempt/retake restarts totalTimeElapsed from 0, allow breakpoints to trigger again
  useEffect(() => {
    const prev = prevTotalTimeElapsedRef.current;
    const curr = totalTimeElapsed;
    if (
      curr != null &&
      (Number(curr) === 0 || (prev != null && Number.isFinite(Number(prev)) && Number(curr) < Number(prev)))
    ) {
      if (askedBreakpoints.length > 0) {
        setAskedBreakpoints([]);
        sessionStorage.removeItem("asked_breakpoints");
      }
    }
    prevTotalTimeElapsedRef.current = curr;
  }, [totalTimeElapsed, askedBreakpoints.length]);

	useEffect(()=>{
    const rawUser = sessionStorage.getItem('user');
    let parsedUser = null;
    try { parsedUser = rawUser ? JSON.parse(rawUser) : null; } catch(_){ parsedUser = null; }
    if(parsedUser && parsedUser.retake_permission === '0' ){
			navigate('/course/course-result-card');
		}
		getQuestions();
	},[]);

	const cancelQuiz=()=>{
		setCurrentQuestionIndex(0);
		setFinalquestions([]);
		navigate('/course/home');
	}
  const submitfinalquiz=async()=>{
    if(Object.keys(finalanswers).length !== finalquestions.length){
      setQuizError(true);
      return;
    }
  
    const token = sessionStorage.getItem("token");
    const user_id = sessionStorage.getItem("user_id");
    const formdata = new FormData();
    formdata.append('user_id', user_id);
    formdata.append('finalanswers',JSON.stringify(finalanswers));
    setFinalanswers({});
    try{
      const response = await submitExam(token, formdata);
      if(response){
      sessionStorage.removeItem("topicStatus");
      sessionStorage.removeItem("lastTopic");
      sessionStorage.setItem("testResult",response.data.score);
      sessionStorage.setItem("total",response.data.total);
      sessionStorage.setItem("user",JSON.stringify(response.data.user));
      sessionStorage.setItem("total_questions",response.data.questions);
      navigate("/course/scoreboard");
      }
    }catch(_){
      // keep UX stable; optionally show error toast here
    }
    }
		
    const handleUserFinalanswer = useCallback((event, questionId) => {
		const selectedAnswer = event.target.value;
		setFinalanswers((prevAnswers) => ({
		  ...prevAnswers,
		  [questionId]: selectedAnswer, 
		}));
      }, []);

    const getQuestions=async()=>{
        const token = sessionStorage.getItem("token");
        const user_id = sessionStorage.getItem("user_id");
        try{
          const response = await getExam(token,user_id);
          if(response){
              const responseData = response.data || {};
              const responseUser = responseData.user ?? responseData.data?.user ?? null;
              if (responseUser) {
                sessionStorage.setItem("user", JSON.stringify(responseUser));
              }
              const backendTotalTimeElapsed =
                responseData.data?.totalTimeElapsed ??
                responseData.data?.total_time_elapsed ??
                responseData.totalTimeElapsed ??
                responseData.total_time_elapsed ??
                responseUser?.totalTimeElapsed ??
                responseUser?.total_time_elapsed ??
                null;
              if (backendTotalTimeElapsed != null && Number.isFinite(Number(backendTotalTimeElapsed))) {
                const elapsedSeconds = Number(backendTotalTimeElapsed);
                setTotalTimeElapsed(elapsedSeconds);
                sessionStorage.setItem("total_time_elapsed", String(elapsedSeconds));
              }
              // Exam-specific breakpoints are set when exam starts, not from user data
              setFinalquestions(response.data.questions);
              setLoading(false);
          }
        }catch(_){
          setLoading(false);
        }
    }
  const handleExam = useCallback(()=>{
    setSplashscreen(false);
  },[]);
  const handleHome = useCallback(()=>{
        navigate("/course/home");
    },[navigate]);
  const handleNextQuestion = useCallback(()=>{
    setCurrentQuestionIndex((prev) => Math.min(prev + 1, finalquestions.length - 1));
  },[finalquestions.length]);

  // Set exam-specific breakpoint when exam starts (randomly between 30-60 mins)
  useEffect(() => {
    if (!splashscreen && !loading) {
      // Randomly generate one breakpoint between 1800 (30 mins) and 3600 (60 mins) seconds
      const minSeconds = 300; // 30 minutes
      const maxSeconds = 350; // 60 minutes
      
      // Generate one random breakpoint
      const examBreakpoint1 = Math.floor(Math.random() * (maxSeconds - minSeconds + 1)) + minSeconds;
      
      setBreakpoint1(examBreakpoint1);
      setBreakpoint2(null); // No second breakpoint for exam
      sessionStorage.setItem("breakpoint1_seconds", String(examBreakpoint1));
      sessionStorage.removeItem("breakpoint2_seconds");
      
      console.log("[Exam] Set random exam-specific breakpoint - BP1:", examBreakpoint1);
    }
  }, [splashscreen, loading, setBreakpoint1, setBreakpoint2]);

  const shouldRunTotalTimeElapsed = !loading && !splashscreen && !showChallengeModal;

  // Update totalTimeElapsed every second during exam
  useEffect(() => {
    if (shouldRunTotalTimeElapsed) {
      const bp1 = breakpoint1 != null ? Number(breakpoint1) : null;

      const interval = setInterval(() => {
        setTotalTimeElapsed((prev) => {
          if (prev === null || prev === undefined) {
            return prev;
          }
          const prevNum = Number(prev);
          if (!Number.isFinite(prevNum)) {
            return prev;
          }
          const next = prevNum + 1;
          sessionStorage.setItem("total_time_elapsed", String(next));

          // Only check for breakpoint1 (one challenge question for exam)
          if (
            bp1 != null &&
            !askedBreakpoints.includes(bp1) &&
            prevNum < bp1 &&
            next >= bp1
          ) {
            setShowChallengeModal(true);
            setAskedBreakpoints((prevAsked) => {
              const updated = [...prevAsked, bp1];
              sessionStorage.setItem("asked_breakpoints", JSON.stringify(updated));
              return updated;
            });
          }

          return next;
        });
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [shouldRunTotalTimeElapsed, breakpoint1, askedBreakpoints, setTotalTimeElapsed, setShowChallengeModal]);

  // Sync elapsed time to backend
  useEffect(() => {
    if (!shouldRunTotalTimeElapsed) {
      return;
    }
    const token = sessionStorage.getItem("token");
    const user_id = sessionStorage.getItem("user_id");
    if (!token || !user_id) {
      return;
    }

    const interval = setInterval(async () => {
      try {
        const elapsed = Number(sessionStorage.getItem("total_time_elapsed"));
        if (!Number.isFinite(elapsed)) {
          return;
        }
        const response = await updateTotalTimeElapsed(token, {
          user_id,
          time_elapsed: elapsed,
        });

        const updatedUser =
          response?.data?.data?.user ?? response?.data?.user ?? null;
        if (updatedUser) {
          sessionStorage.setItem("user", JSON.stringify(updatedUser));
        }
      } catch (_) {
        // keep UX stable; optionally show error toast here
      }
    }, 10000);

    return () => clearInterval(interval);
  }, [shouldRunTotalTimeElapsed]);

  if(splashscreen){
    return( <div className="container ">
          <div className="row">
            <div className="col-lg-7 ps-lg-5 mt-4">
              <div className="p-4 mt-4">
                <div className="heading mt-4 d-flex justify-content-center">
                  <span className="retake-heading mt-4">Retake Exam</span>
                </div>
                <div className="score-heading d-flex justify-content-center mt-4">
                  <span className="splash-screen-text mt-4">The retake exam will be presented in one, 40 question exam.   You must complete this exam in one session.  If you choose to leave before completing this exam you will be required to restart the full exam.<br></br>Click on “Exam Retake” when you are ready to begin this process.</span><br></br>
                  <span></span>
                </div>
                <div className="action-buttons  d-flex justify-content-around">
                <button  data-bs-toggle="modal" data-bs-target="#cancelexamModal" className="retake-btn">
                  <i className="fa fa-arrow-left fs-12"></i> Exit
                </button>
                <button onClick={handleExam} className="retake-btn">Exam Retake</button>
                {/* <button onClick={handleHome} className="retake-btn">HOME</button> */}
                </div>
              </div>
            </div>
            <div className="col-md-5 col-lg-5 d-flex justify-content-start  mt-4">
              <div className="mt-4">
                <img className="image-security" src={startnow} width={500} height={500}/>
              </div>
            </div>
          </div>

        </div>);
  }

	return(<>{loading?<div className="loader position-fixed top-0 bottom-0 start-0 end-0 bg-dark">
		<span className="position-absolute top-50 start-50 translate-middle"><img src={Loader} alt="Loader"  /></span>
		</div>:<>
		<div className="d-flex justify-content-center">
      <div className="final-screen text-align-center">
      {quizerror?(<><span className="text-danger alert-error">Select at least One Option</span><br></br><br></br></>):(<></>)} 
      {finalquestions.map((question, index) => (
          index === currentQuestionIndex && ( // Only render the current question
            <div key={index} className="mt-4">
              <span className="question">{question.question}</span>
              <br />
              <div className="d-flex mt-4 justify-content-around">
                {question.option_one && (
                  <>
                    <input
                      type="radio"
                      className="d-none"
                      id={`${question.option_one}${question.id}`}
                      name={`question_${question.id}`}
                      onChange={(e) => handleUserFinalanswer(e, question.id)}
                      value="A"
                    />
                    <label
                      className="customTab"
                      htmlFor={`${question.option_one}${question.id}`}
                    >
                      {question.option_one}
                    </label>
                  </>
                )}
                {question.option_two && (
                  <>
                    <input
                      type="radio"
                      className="d-none"
                      id={`${question.option_two}${question.id}`}
                      name={`question_${question.id}`}
                      onChange={(e) => handleUserFinalanswer(e, question.id)}
                      value="B"
                    />
                    <label
                      className="customTab"
                      htmlFor={`${question.option_two}${question.id}`}
                    >
                      {question.option_two}
                    </label>
                  </>
                )}
              </div>
              <div className="d-flex mt-4 justify-content-around">
                {question.option_three && (
                  <>
                    <input
                      type="radio"
                      className="d-none"
                      id={`${question.option_three}${question.id}`}
                      name={`question_${question.id}`}
                      onChange={(e) => handleUserFinalanswer(e, question.id)}
                      value="C"
                    />
                    <label
                      className="customTab"
                      htmlFor={`${question.option_three}${question.id}`}
                    >
                      {question.option_three}
                    </label>
                  </>
                )}
                {question.option_four && (
                  <>
                    <input
                      type="radio"
                      className="d-none"
                      id={`${question.option_four}${question.id}`}
                      name={`question_${question.id}`}
                      onChange={(e) => handleUserFinalanswer(e, question.id)}
                      value="D"
                    />
                    <label
                      className="customTab"
                      htmlFor={`${question.option_four}${question.id}`}
                    >
                      {question.option_four}
                    </label>
                  </>
                )}
              </div>
            </div>
          )
        ))}

        <div className="mt-3" style={{ maxWidth: "520px", margin: "0 auto" }}>
          <div
            style={{
              backgroundColor: '#ffffff',
              border: '1px solid #00AAAA',
              borderRadius: '6px',
              padding: '8px',
              boxShadow: '0 1px 6px rgba(0, 0, 0, 0.08)',
              fontFamily: 'monospace',
              fontSize: '10px',
            }}
          >
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '6px',
              paddingBottom: '4px',
              borderBottom: '1px solid #00AAAA'
            }}>
              <h6 style={{
                margin: 0,
                color: '#00AAAA',
                fontWeight: 'bold',
                fontSize: '11px'
              }}>
                QA Panel (Preview)
              </h6>
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', flexWrap: 'wrap' }}>
              <div style={{
                backgroundColor: '#f8f9fa',
                padding: '6px 8px',
                borderRadius: '4px',
                border: '1px solid #dee2e6',
                flex: '1',
                minWidth: '120px'
              }}>
                <div style={{
                  fontWeight: 'bold',
                  color: '#495057',
                  marginBottom: '2px',
                  fontSize: '9px',
                  textTransform: 'uppercase'
                }}>
                  Time Elapsed
                </div>
                <div style={{
                  color: '#00AAAA',
                  fontWeight: 'bold',
                  fontSize: '12px',
                  fontFamily: 'monospace',
                  lineHeight: '1.2'
                }}>
                  {formatTime(totalTimeElapsed)}
                </div>
                <div style={{
                  color: '#6c757d',
                  fontSize: '9px',
                  marginTop: '2px'
                }}>
                  ({totalTimeElapsed !== null ? `${totalTimeElapsed}s` : 'N/A'})
                </div>
              </div>

              <div style={{
                backgroundColor: '#fff3cd',
                padding: '6px 8px',
                borderRadius: '4px',
                border: '1px solid #ffc107',
                flex: '1',
                minWidth: '120px'
              }}>
                <div style={{
                  fontWeight: 'bold',
                  color: '#856404',
                  marginBottom: '2px',
                  fontSize: '9px',
                  textTransform: 'uppercase'
                }}>
                  Breakpoint
                </div>
                <div style={{
                  color: '#856404',
                  fontWeight: 'bold',
                  fontSize: '12px',
                  fontFamily: 'monospace',
                  lineHeight: '1.2'
                }}>
                  {breakpoint1 !== null ? `${breakpoint1}s` : 'Not Set'}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-4 quiz-timer">
          <div className="row mt-3">
            <div className="col-lg-2 mt-4">
              {/* <button onClick={cancelQuiz} className="btn btn-secondary-s mb-3 btn-lg w-90 text-white">
                <i className="fa fa-arrow-left fs-12"></i> Exit
              </button> */}
              <button  data-bs-toggle="modal" data-bs-target="#cancelexamModal" className="btn btn-secondary-s mb-3 btn-md  w-90 text-white">
                <i className="fa fa-arrow-left fs-12"></i> Exit
              </button>
            </div>

            <div className="col-lg-8 col-md-6 mt-4">
              <div className="d-flex justify-content-between gap-4">
                <button
                  className="btn btn-secondary-s text-white btn-lg w-100 rounded-2"
                  onClick={handleNextQuestion}
                  disabled={canGoNext}
                >
                  Next
                </button>
              </div>
            </div>

            {/* <div className="col-2">
              <CountdownCircleTimer
                isPlaying
                duration={5400}
                size={100}
                colors="#0BA8CF"
                onUpdate={(remainingTime) => {
                  setCurrentquiztime(remainingTime);
                  if (remainingTime === 0) {
                    cancelQuiz();
                  }
                }}
              >
                {() => {
                  const minutes = Math.floor(currentquiztime / 60);
                  const seconds = currentquiztime % 60;
                  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
                }}
              </CountdownCircleTimer>
            </div> */}
          </div>
        </div>

        {currentQuestionIndex === finalquestions.length - 1 && (
          <div className="container mt-4">
            <button
              className="btn btn-primary-s text-white btn-lg w-100 rounded-2"
              onClick={submitfinalquiz}
            >
              Submit
            </button>
          </div>
        )}
      </div>
    </div>
  
		</>}
	</>);
}

export default Exam;